import { FaPlus } from "react-icons/fa"
import { IoTerminalOutline } from "react-icons/io5"
import { useNavigate } from "react-router"

const BuildButton = () => {
  const navigate = useNavigate()

  return <button onClick={() => {
    navigate('/v2/build')
  }} className="bg-[#263dff] h-[40px] w-[160px] text-[#fff] flex items-center text-lg">
    <span className="flex items-center w-[120px] justify-center gap-2 h-full border-r border-[#162ce1]">
      <IoTerminalOutline /> BUILD
    </span>
    <div className="w-[40px] h-[40px] flex items-center justify-center">
      <FaPlus size={16} />
    </div>
  </button>
}

export default BuildButton